import { Injectable } from '@angular/core';
import { StoreConfigStatus } from '@app/store/store-grid';
import { POSProviderType } from '@interfaces/pos-integration/1.0';
import { Store, StoreStatus, StoreView } from '@interfaces/store/1.0';
import { IsNumberService } from '@services/utilities/1.0/is-number.service';
@Injectable({
  providedIn: 'root',
})
export class StoreConfigStatusService {
  /**
   * Returns a boolean indicating if the store has all the steps completed necessary to be enabled
   *
   * @param store - Store to check
   */
  getConfigStatus(store: Store): StoreConfigStatus {
    const hasPrepTime = IsNumberService.isNumber(store.prepTime);
    const hasStoreHours = store.isStoreHoursSet;
    const hasActivationId =
      (store.posProvider === POSProviderType.RestaurantIntegration &&
        !!store.posIntegrationConfigurations?.externalPosRegistrationId) ||
      (store.posProvider === POSProviderType.POS_SPI &&
        !!store.posIntegrationConfigurations?.externalPosProviderId);
    const hasAggregator = store.aggregators?.some((agg) => agg.enabled);
    const isOnlineAndReady = store.status?.status === StoreStatus.ONLINE_AND_READY;
    const hasDefaultTaxRate = IsNumberService.isNumber(store.taxRate);
    const hasMenus = true;
    const isStatusOpen = store.isStatusOpen;
    const status: StoreConfigStatus = {
      hasAggregator,
      hasDefaultTaxRate,
      hasPrepTime,
      hasStoreHours,
      isOnlineAndReady,
      hasMenus,
      isStatusOpen,
    };
    return status;
  }

  getStoreGridConfigStatus(store: StoreView): StoreConfigStatus {
    const hasPrepTime = store.isPrepTimeSet;
    const hasStoreHours = store.isStoreHoursSet;
    //does not have POS info to validate activation id
    const isStatusOpen = store.isStatusOpen;
    //does not have Aggregator info to validate has aggregators
    const hasAggregator = store.isChannelSetup;
    const isOnlineAndReady = store.isPosOnlineAndReady;
    const hasDefaultTaxRate = store.isDefaultTaxRateSet;
    const hasMenus = true;
    const status: StoreConfigStatus = {
      hasAggregator,
      hasDefaultTaxRate,
      hasPrepTime,
      hasStoreHours,
      isOnlineAndReady,
      hasMenus,
      isStatusOpen,
    };

    return status;
  }

  /**
   * Returns true if the StoreConfigStatus has everything true
   *
   * @param status - status to check
   */
  isStoreReady(status: StoreConfigStatus): boolean {
    return (
      status.hasAggregator &&
      status.hasPrepTime &&
      status.hasStoreHours &&
      status.isOnlineAndReady &&
      status.hasDefaultTaxRate &&
      status.hasMenus &&
      status.isStatusOpen
    );
  }
}
